<!-- PrivacyDialog.vue -->
<template>
  <el-dialog
    title="用户协议"
    :visible="visible"
    width="50%"
    @close="handleClose"
    @update:visible="updateVisible"
  >
    <div class="text">
      {{this.text}}
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PrivacyDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: `EYE质控用户协议
尊敬的用户：
欢迎您使用“EYE质控” APP，EYE质控 APP由复旦大学附属眼耳鼻喉科医院有限公司开发并运营。在申请注册流程中点击同意本协议之前，请您务必审慎阅读、充分理解各条款内容，如您未满18周岁，或以其他形式被限制民事行为能力，请在监护人的陪同下阅读本协议。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，成为EYE质控 APP平台用户。您的注册行为将被认为是对本协议全部条款无保留的接受和遵守。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
一、用户及注册：
1.1 EYE质控 APP提供用户注册。您的帐号和密码由您自行保管；您应当对以您的帐号进行的所有活动和事件负法律责任。
1.2 用户提供的注册资料应真实、完整、准确，用户资料如有变动的，应及时更新其注册资料。
1.3 注册成功后，即成为EYE质控 APP平台用户，您将拥有自己在EYE质控 APP平台的用户名及密码，并有权利使用自己的用户名及密码随时登陆EYE质控 APP。您可以根据本平台规定修改您的密码，本平台将对您的各项信息承担严格的保密责任。
1.4 用户不得将在本平台注册成功的账户借给他人使用，亦不得盗用他人帐号，否则用户应承担由此产生的全部责任。
二、服务内容：
2.1 EYE质控 APP提供在线耳内镜、口咽、鼻腔诊断，用药记录，病情变化记录，科普中耳炎诊疗知识、专家在线咨询等线上服务。
2.2 EYE质控 APP服务的具体内容由复旦大学附属眼耳鼻喉科医院有限公司提供，复旦大学附属眼耳鼻喉科医院有限公司保留随时变更、中断或终止部分或全部网络服务的权利。
2.3 EYE质控 APP平台有义务在现有技术上维护整个网络平台的正常运行，并努力提升和改进版本内容及技术，更好的满足用户需求。
2.4 EYE质控 APP平台拥有通过短信、电话、电子邮件等形式，向注册用户发送信息等告知信息的权利。
2.5 在不透露您的保密信息的前提下，EYE质控 APP平台有权对用户数据库进行整合、分析并将所得内容公开发表。
三、免责声明：
3.1 EYE质控 APP平台根据用户耳鸣自助检测结果定制生成治疗方案，并给予合理指导和建议。
3.2 线上诊疗并不能代替传统的医患面对面就诊方式，EYE质控 APP平台将通过耳鸣科普平台及耳鸣咨询服务提供线下就医的合理建议，您有权选择是否遵从，本平台不承担相应的责任。
3.3 因不可抗力、网络状况、通讯线路、用户自身过错等技术原因，或其他不可控原因导致您不能正常使用EYE质控 APP服务，复旦大学附属眼耳鼻喉科医院有限公司不承担相应责任。
四、服务变更、中断或终止：
4.1 因系统维护或升级的需要而需暂停网络服务，EYE质控 APP将尽可能事先进行通告。
4.2 服务发生变更、中断、终止后，本平台有权保留您的注册数据及以前的行为记录。
五、服务条款修改：
5.1 复旦大学附属眼耳鼻喉科医院有限公司有权根据服务情况变更、终止EYE质控 APP管理规定的各项条款，并将通过适当方式向您提示修改内容。更新后的协议条款一旦公布即替代原来的协议条款，用户可在本APP中查阅最新版协议条款。
5.2 如果您不同意EYE质控 APP所做的修改，有权停止使用网络服务。如果您继续使用网络服务，则视为您接受EYE质控 APP对相关服务条款所做的修改。
六、注销账号：
您随时可注销此前注册的账户，通过以下方式自行操作： 打开APP个人中心->系统设置->“注销账号”完成相关注销操作 在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
公司名称：复旦大学附属眼耳鼻喉科医院
企业地址：上海市汾阳路83号
联系方式：781120244@qq.com
2025年1月9日`
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false); // 手动关闭
    },
    updateVisible(val) {
      this.$emit('update:visible', val); // 同步 visible 值
    }
  }
}
</script>

<style lang="less" scoped>
  .text{
    white-space: pre-wrap; /* 保留换行和空格 */
    word-break: break-word;
    font-size: 16px;
    line-height: 30px;
    color: #000;
    text-align: left;
    height: 500px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/index2.vue